import { useComments, useCommentsDispatch } from "../../context/CommentsProvider"
import { useSettings } from "../../context/SettingsProvider";

export default function CommentsHeader(){

	const settings = useSettings();
	const commentsContext = useComments();
	const commentsDispatch = useCommentsDispatch();

	const onOrderChange = (e) => {
		commentsDispatch({
			type: 'order',
			order: e.target.value
		})
	}

	return (
		(settings.isCommentsOpen || !!commentsContext.count) &&
		<div className={settings.isLoading ? "comments--header is-loading" : "comments--header"}>
			<span class="comments--header-count">
				Comments ({commentsContext.count})
			</span>

			<div class="comments--header-controls">
				<select
					class="order-control" 
					onChange={onOrderChange}
					disabled={settings.isLoading ? true : false}
				>
					<option value="asc" selected={commentsContext.order === 'asc'}>Oldest First</option>
					<option value="desc" selected={commentsContext.order === 'desc'}>Newest First</option>
				</select>
			</div> 
		</div>
	)
}